import React from 'react';
import { useHistory } from 'react-router-dom';
import AdvanceCurriculumView from './AdvanceCurriculumView';
import useTitle from '@/presentation/hooks/useTitle';

const AdvanceCurriculumController = () => {
  const history = useHistory();

  const handlerBack = () => history.push('/cursos');

  useTitle('Avance plan de estudios');

  return <AdvanceCurriculumView handlerBack={handlerBack} />;
};

export default AdvanceCurriculumController;
